<template>
  <div class="paas-table-expand">
    <Row v-for="(data, index) in rowData.datas" class="expand-row" :key="data.sysEnumDataId">
      <Col span="4">
        &nbsp;
      </Col>
      <Col span="2">
        {{index + 1}}
      </Col>
      <Col span="3">
        <span class="expand-value">{{ data.sysEnmuDataKey }}</span>
      </Col>
      <Col span="3">
        <span class="expand-value">{{ data.sysEnmuDataValue }}</span>
      </Col>
      <Col span="3">
        <span class="expand-value"><EnumShow :enum-group-code="'base'" :enum-code="'isDefaultValue'" :value="data.isDefaultValue"></EnumShow></span>
      </Col>
      <Col span="3">
        <Button type="default" icon="ios-trash-outline" @click="deleteEnumData(data.sysEnumDataId)"></Button>
      </Col>
    </Row>
    <Modal v-model="paasDeleteConfirmModel" title="系统提示" @on-ok="paasConfirmDelete" @on-cancel="paasDeleteConfirmModel = false">
      <p>确定要删除吗？</p>
    </Modal>
  </div>
</template>

<script>
  import EnumShow from '@/components/paas/enum-show';
  export default {
    components: {EnumShow},
    data() {
      return {
        paasDeleteConfirmModel: false,
        paasDeleteDataIds: ''
      }
    },
    props: {
      rowData: Object
    },
    methods: {
      deleteEnumData(sysEnumDataId) {
        this.paasDeleteConfirmModel = true;
        this.paasDeleteDataIds = sysEnumDataId;
      },
      paasConfirmDelete() {
        let that = this;
        this.axios.get(this.$store.state.sysApi+"/sys/enum/data/delete?sysEnumDataIds="+that.paasDeleteDataIds).then(function (res) {
          that.paasDeleteConfirmModel = false;
          if(res.body.code == 200) {
            that.$Message.info('数据删除成功！');
            let datas = that.rowData.datas;
            let newDatas = [];
            for(let i = 0; i < datas.length; i++) {
              if(datas[i].sysEnumDataId != that.paasDeleteDataIds) {
                newDatas.push(datas[i]);
              }
            }
            that.rowData.datas = newDatas;
          }
        }).catch(function (error) {
          that.paasDeleteConfirmModel = false;
          that.$Message.info('数据删除失败，请重试！');
        });
      }
    }
  }
</script>

<style scoped>

</style>
